/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetIntegrationsConfig200ResponseEmailForwarding } from './GetIntegrationsConfig200ResponseEmailForwarding';
import {
    GetIntegrationsConfig200ResponseEmailForwardingFromJSON,
    GetIntegrationsConfig200ResponseEmailForwardingFromJSONTyped,
    GetIntegrationsConfig200ResponseEmailForwardingToJSON,
    GetIntegrationsConfig200ResponseEmailForwardingToJSONTyped,
} from './GetIntegrationsConfig200ResponseEmailForwarding';
import type { UpdateIntegrationsConfigRequestAutotask } from './UpdateIntegrationsConfigRequestAutotask';
import {
    UpdateIntegrationsConfigRequestAutotaskFromJSON,
    UpdateIntegrationsConfigRequestAutotaskFromJSONTyped,
    UpdateIntegrationsConfigRequestAutotaskToJSON,
    UpdateIntegrationsConfigRequestAutotaskToJSONTyped,
} from './UpdateIntegrationsConfigRequestAutotask';
import type { UpdateIntegrationsConfigRequestNinjaOne } from './UpdateIntegrationsConfigRequestNinjaOne';
import {
    UpdateIntegrationsConfigRequestNinjaOneFromJSON,
    UpdateIntegrationsConfigRequestNinjaOneFromJSONTyped,
    UpdateIntegrationsConfigRequestNinjaOneToJSON,
    UpdateIntegrationsConfigRequestNinjaOneToJSONTyped,
} from './UpdateIntegrationsConfigRequestNinjaOne';
import type { UpdateIntegrationsConfigRequestTehtris } from './UpdateIntegrationsConfigRequestTehtris';
import {
    UpdateIntegrationsConfigRequestTehtrisFromJSON,
    UpdateIntegrationsConfigRequestTehtrisFromJSONTyped,
    UpdateIntegrationsConfigRequestTehtrisToJSON,
    UpdateIntegrationsConfigRequestTehtrisToJSONTyped,
} from './UpdateIntegrationsConfigRequestTehtris';

/**
 * 
 * @export
 * @interface UpdateIntegrationsConfigRequest
 */
export interface UpdateIntegrationsConfigRequest {
    /**
     * 
     */
    tehtris?: UpdateIntegrationsConfigRequestTehtris;
    /**
     * 
     */
    autotask?: UpdateIntegrationsConfigRequestAutotask;
    /**
     * 
     */
    ninjaOne?: UpdateIntegrationsConfigRequestNinjaOne;
    /**
     * 
     */
    emailForwarding?: GetIntegrationsConfig200ResponseEmailForwarding;
}

/**
 * Check if a given object implements the UpdateIntegrationsConfigRequest interface.
 */
export function instanceOfUpdateIntegrationsConfigRequest(value: object): value is UpdateIntegrationsConfigRequest {
    return true;
}

export function UpdateIntegrationsConfigRequestFromJSON(json: any): UpdateIntegrationsConfigRequest {
    return UpdateIntegrationsConfigRequestFromJSONTyped(json, false);
}

export function UpdateIntegrationsConfigRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateIntegrationsConfigRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tehtris': json['tehtris'] == null ? undefined : UpdateIntegrationsConfigRequestTehtrisFromJSON(json['tehtris']),
        'autotask': json['autotask'] == null ? undefined : UpdateIntegrationsConfigRequestAutotaskFromJSON(json['autotask']),
        'ninjaOne': json['ninjaOne'] == null ? undefined : UpdateIntegrationsConfigRequestNinjaOneFromJSON(json['ninjaOne']),
        'emailForwarding': json['emailForwarding'] == null ? undefined : GetIntegrationsConfig200ResponseEmailForwardingFromJSON(json['emailForwarding']),
    };
}

export function UpdateIntegrationsConfigRequestToJSON(json: any): UpdateIntegrationsConfigRequest {
    return UpdateIntegrationsConfigRequestToJSONTyped(json, false);
}

export function UpdateIntegrationsConfigRequestToJSONTyped(value?: UpdateIntegrationsConfigRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tehtris': UpdateIntegrationsConfigRequestTehtrisToJSON(value['tehtris']),
        'autotask': UpdateIntegrationsConfigRequestAutotaskToJSON(value['autotask']),
        'ninjaOne': UpdateIntegrationsConfigRequestNinjaOneToJSON(value['ninjaOne']),
        'emailForwarding': GetIntegrationsConfig200ResponseEmailForwardingToJSON(value['emailForwarding']),
    };
}

